import React from "react";
import { Box } from "@mui/material";

interface MicrosoftSignInButtonProps {
  onClick: () => void;
  text?: string;
}

const MicrosoftSignInButton: React.FC<MicrosoftSignInButtonProps> = ({
  onClick,
  text = "Sign up with Microsoft",
}) => {
  return (
    <Box
      component="button"
      onClick={onClick}
      sx={{
        userSelect: "none",
        WebkitAppearance: "none",
        backgroundColor: "white",
        backgroundImage: "none",
        border: "1px solid #8c8c8c",
        borderRadius: "20px",
        boxSizing: "border-box",
        color: "#5e5e5e",
        cursor: "pointer",
        fontFamily:
          "'Segoe UI', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        fontSize: "15px",
        height: "41px",
        outline: "none",
        overflow: "hidden",
        padding: "0 12px",
        position: "relative",
        textAlign: "center",
        transition: "background-color .2s ease, border-color .2s ease",
        verticalAlign: "middle",
        whiteSpace: "nowrap",
        width: "auto",
        maxWidth: "400px",
        minWidth: "min-content",
        "&:hover": {
          backgroundColor: "#f3f3f3",
          borderColor: "#8c8c8c",
        },
        "&:active": {
          backgroundColor: "#e5e5e5",
        },
        "&:disabled": {
          cursor: "default",
          backgroundColor: "#f3f3f3",
          borderColor: "#d6d6d6",
          color: "#a6a6a6",
          opacity: 0.6,
        },
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          height: "100%",
          justifyContent: "space-between",
          position: "relative",
          width: "100%",
        }}
      >
        <Box
          sx={{
            height: "21px",
            marginRight: "12px",
            minWidth: "21px",
            width: "21px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
          >
            <rect x="1" y="1" width="9" height="9" fill="#F25022" />
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
            <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
          </svg>
        </Box>
        <Box
          component="span"
          sx={{
            flexGrow: 1,
            fontWeight: 600,
            overflow: "visible",
            textOverflow: "ellipsis",
            verticalAlign: "top",
            lineHeight: "normal",
          }}
        >
          {text}
        </Box>
      </Box>
    </Box>
  );
};

export default MicrosoftSignInButton;
